import React from "react";
// import "bootstrap-icons/font/bootstrap-icons.css";

const Disclaimer = () => {
  return (
    <div>
 
      <section className="section-padding-100">
        <div className="container">

          <div className="privacy-content">

            <h4>1. General Information</h4>
            <p>
              The information provided on the Finbasket website is for general 
              informational purposes only. While we strive to keep the information 
              accurate and up to date, we make no warranties or representations 
              of any kind regarding the completeness, accuracy, reliability, or 
              suitability of the information, products, or services mentioned.
            </p>

            <h4>2. No Lending Commitment</h4>
            <p>
              Finbasket is not a bank or financial institution. We act solely as 
              a facilitator between customers and partner banks or NBFCs. Loan 
              approval, interest rates, tenure, and disbursement are subject to 
              the policies and final decision of the respective lender.
            </p>

            <h4>3. No Financial Advice</h4>
            <p>
              The content available on this website does not constitute financial, 
              legal, or professional advice. Users are advised to independently 
              verify loan terms and consult with qualified financial advisors 
              before making any borrowing decisions.
            </p>

            <h4>4. Third-Party Links</h4>
            <p>
              Our website may contain links to third-party websites or services. 
              Finbasket does not control or endorse the content, policies, or 
              practices of any third-party websites and shall not be responsible 
              for any loss or damage arising from their use.
            </p>

            <h4>5. Limitation of Liability</h4>
            <p>
              Finbasket shall not be held liable for any direct, indirect, incidental, 
              consequential, or special damages arising out of or in connection 
              with the use of this website or our services, including but not 
              limited to loan rejection, processing delays, or changes in lender policies.
            </p>

            <h4>6. Accuracy of Information</h4>
            <p>
              Loan features, interest rates, eligibility criteria, and other 
              details displayed on the website are subject to change without 
              prior notice as per lender updates or regulatory guidelines.
            </p>

            <h4>7. Consent</h4>
            <p>
              By using the Finbasket website, you hereby consent to this disclaimer 
              and agree to its terms.
            </p>

            <h4>8. Updates</h4>
            <p>
              Finbasket reserves the right to modify this Disclaimer at any time 
              without prior notice. Users are encouraged to review this page 
              periodically for any changes.
            </p>

          </div>

        </div>
      </section>

      <style>{`
        .privacy-content h4 {
          margin-top: 25px;
          font-weight: 600;
        }

        .privacy-content p {
          margin-top: 10px;
          line-height: 1.7;
          color: #555;
        }
      `}</style>

    </div>
  );
};

export default Disclaimer;
